import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faPerson } from '@fortawesome/free-solid-svg-icons';
import Portfolio from './Portfolio';
import Footer from './Footer';
import gideon from './gideon.png';


function App() {
  return (
<div className='App'>
<h1 className='vi'>my name is GIDEON</h1>

<div className='ttj'>
<div className='ttm'>
<div className="robot-card">
<img src={gideon} className='rob'/>
<p className="tex1">Reach out to me from anywhere in the world</p>
<a href="/newCV.pdf" download>
<p className='button'>DOWNLOAD CV</p>
</a>
</div>

<div className='self'>
<FontAwesomeIcon icon={faPerson} size="5x" />
<h1 className='iu'>about my self</h1>
<p className='lu'>I'm a full-time React frontend developer 
  with a passion for building intuitive, user-friendly interfaces. I also do part-time backend development,
   giving me a solid understanding of full-stack applications and seamless integration between front and back end</p>
</div>
</div>
</div>


<div className='spk'>
  <div className='uuj'>professional skill
  <p>JavaScript</p>
  <p>React</p>
  <p>node.js</p>
  <p>C#</p>
  </div>


  <div className='uuj'>Experience
  <p>JavaScript 3+years</p>
  <p>React 3+years</p>
  <p>node.js  1+years</p>
  <p>C# 2+years</p>
  </div>

  <div className='uuj'>my services
  <p>Custom Website Design</p>
  <p>Website Redesign</p>
  <p>E-commerce Solutions</p>
  <p>SEO Optimization</p>
  <p>Maintenance & Support</p>
  </div>
</div>
<Portfolio/>
<Footer/>
</div>
  );
}

export default App;
